"use strict";

$(function() {

	// 処方箋の画像・電子処方箋のラジオボタン押下時の処理
	if ($('#rx-type-0').length > 0 && $('#rx-type-1').length) {
		var photograph_texts = {
			rx_type_0 : {
				name: '処方箋の画像',
				camera: 'カメラボタンを押して、処方箋もしくは処方内容（控え）を撮影してください',
				caution: '処方箋以外の画像はご利用いただけません。別画像を添付された場合は、ご利用を制限させていただく場合があります。'
			},
			rx_type_1 : {
				name: '処方内容（控え）の画像',
				camera: 'カメラボタンを押して、処方内容（控え）を撮影してください',
				caution: '処方内容（控え）以外の画像はご利用いただけません。別画像を添付された場合は、ご利用を制限させていただく場合があります。'
			}
		};

		if ($('#rx-type-0').prop('checked')) {
			$('#prescription_name')[0].childNodes[1].nodeValue = photograph_texts['rx_type_0'].name;
			$('#how_to_photograph').text(photograph_texts['rx_type_0'].camera);
			$('.camera-caution-txt').text(photograph_texts['rx_type_0'].caution);
		} else if ($('#rx-type-1').prop('checked')){
			$('#prescription_name')[0].childNodes[1].nodeValue = photograph_texts['rx_type_0'].name;
			$('#how_to_photograph').text(photograph_texts['rx_type_1'].camera);
			$('.camera-caution-txt').text(photograph_texts['rx_type_1'].caution);
		}

		$('#rx-type-0').off('click').on('click', function(){
			$('#prescription_name')[0].childNodes[1].nodeValue = photograph_texts['rx_type_0'].name;
			$('#how_to_photograph').text(photograph_texts['rx_type_0'].camera);
			$('.camera-caution-txt').text(photograph_texts['rx_type_0'].caution);
		});

		$('#rx-type-1').off('click').on('click', function(){
			$('#prescription_name')[0].childNodes[1].nodeValue = photograph_texts['rx_type_1'].name;
			$('#how_to_photograph').text(photograph_texts['rx_type_1'].camera);
			$('.camera-caution-txt').text(photograph_texts['rx_type_1'].caution);
		});
	}

	var checkSubmitBtn = function() {
		if ($('#shown_thumbnail_images_count').length > 0 && $('[name=e_rx_reserve_type]:checked').val() != 1) {
			var count = 0;
			$.each($('.thm, .thumbnail'), function(i, el) {
				if ($(el).css('display') != 'none') {
					count++;
				}
			});
			if (count == 0) {
				// 確認画面への遷移不可
				$('#confirm-btn').prop('disabled', true);
				$('#confirm-btn').val('登録した画像は0枚です');
			} else {
				$('#confirm-btn').prop('disabled', false);
				$('#confirm-btn').val('上記に同意して進む');
			}
		} else {
			$('#confirm-btn').prop('disabled', false);
			$('#confirm-btn').val('上記に同意して進む');
		}
	}
	if (location.pathname != '/shoho/prescription'){
		checkSubmitBtn();
	}

	var checkMaxCount = function() {
		var max = 9;

		return ($('.num-input input').length >= max) ? true : false;
	};

	var addExchangeInput = function() {
		if (checkMaxCount()) {
			// 引換番号の追加を中止
			$('.form-parts .input-box .add-btn a.addition').hide();
			$('.family-add-btn').hide();
		} else {
			$('.form-parts .input-box .add-btn a.addition').show();
			$('.family-add-btn').show();
		}
	};
	addExchangeInput();

	var getInfoIndex = function() {
		var _infoindex = 0;
		$('#rxtype1 .e-prescription').each(function(i,e) {
			if (_infoindex < $(e).data('infoindex')) {
				_infoindex = $(e).data('infoindex');
			}
		});

		return _infoindex;
	}

	var initEvent = function() {
		$('.form-parts .input-box .add-btn a.addition')
		.off('click.exadd')
		.on('click.exadd', function() {
			var infoIndex = $(this).data('infoindex');
			var tar = $(this).closest('.input-box');
			var numIndex = tar.data('numindex') + 1;
			var elem = ''
				+ '<div class="num-input">'
				+ '  <ul>'
				+ '    <li class="num"><input type="text" name="info-' + infoIndex + '-number-' + numIndex + '" placeholder="半角数字"></li>'
				+ '    <li class="add-btn"><a href="javascript:void(0);" class="addition" data-infoindex="' + infoIndex + '"></a><a href="javascript:void(0);" class="delete"></a></li>'
				+ '  </ul>'
				+ '</div>';
			tar.append(elem);
			tar.data('numindex', numIndex);
			addExchangeInput();
			initEvent();
		});

		$('.form-parts .input-box .add-btn a.delete')
		.off('click.exdel')
		.on('click.exdel', function() {
			$(this).closest('.num-input').remove();
			addExchangeInput();
		});

		$('.delete-btn a')
		.off('click.del')
		.on('click.del', function() {
			$(this).closest('.e-prescription').remove();
			addExchangeInput();
		});

		$('.family-add-btn a')
		.off('click.familyaddbtn')
		.on('click.familyaddbtn', function() {
			var infoIndex = getInfoIndex() + 1;
			var tar = $('.family-add-btn');
			var elem = ''
				+ '  <div class="e-prescription" data-infoindex="' + infoIndex + '">'
				+ '    <div class="reserve-info-box">'
				+ '      <div class="card-sample">'
				+ '        <input type="checkbox" id="sample_open_' + infoIndex + '">'
				+ '        <label for="sample_open_' + infoIndex + '">処方内容（控え）の見本</label>'
				+ '        <div class="sample"><img src="' + EPK.EP.ImageSource.cameraSample + '" alt=""></div>'
				+ '      </div>'
				+ '      <h2 class="title">患者さまの情報を入力してください</h2>'
				+ '      <p class="sub-txt">送付する処方箋に記載された患者様の情報を入力してください</p>'
				+ '      <div class="form-box patient-information">'
				+ '        <ul class="form-parts">'
				+ '          <li class="name"><span class="required">必須</span>お名前</li>'
				+ '          <li>'
				+ '            <div class="input-box" data-numindex="1">'
				+ '              <div class="input">'
				+ '                <ul class="flex-input name-type">'
				+ '                  <li><input type="text" name="info-' + infoIndex + '-name1" placeholder="例）山田" maxlength="32"></li>'
				+ '                  <li><input type="text" name="info-' + infoIndex + '-name2" placeholder="例）太郎" maxlength="32"></li>'
				+ '                </ul>'
				+ '              </div>'
				+ '            </div>'
				+ '          </li>'
				+ '        </ul>'
				+ '        <ul class="form-parts">'
				+ '          <li class="name"><span class="required">必須</span>生年月日</li>'
				+ '          <li>'
				+ '            <div class="input-box" data-numindex="1">'
				+ '              <div class="input">'
				+ '                <ul class="flex-input day-type">'
				+ '                  <li>'
				+ '                    <label class="select-box send">'
				+ '                      <select class="select-box send" name="info-' + infoIndex + '-birthday[year]">'
				+ $("[name='info-1-birthday[year]']").html()
				+ '                      </select>'
				+ '                    </label>'
				+ '                    年'
				+ '                  </li>'
				+ '                  <li>'
				+ '                    <label class="select-box send">'
				+ '                      <select class="select-box send" name="info-' + infoIndex + '-birthday[month]">'
				+ $("[name='info-1-birthday[month]']").html()
				+ '                      </select>'
				+ '                    </label>'
				+ '                    月'
				+ '                  </li>'
				+ '                  <li>'
				+ '                    <label class="select-box send"">'
				+ '                      <select class="select-box send" name="info-' + infoIndex + '-birthday[day]">'
				+ $("[name='info-1-birthday[day]']").html()
				+ '                      </select>'
				+ '                    </label>'
				+ '                    日'
				+ '                  </li>'
				+ '                </ul>'
				+ '              </div>'
				+ '            </div>'
				+ '          </li>'
				+ '        </ul>'
				+ '      </div>'
				+ '      <h2 class="title">引換番号を入力してください</h2>'
				+ '      <div class="form-box">'
				+ '        <ul class="form-parts">'
				+ '          <li class="name exchange"><span class="required">必須</span>引換番号 </li>'
				+ '          <li>'
				+ '            <p class="add-ttl">ご不明の場合は、処方された病院・クリニックにお問い合わせください</p>'
				+ '            <div class="input-box" data-numindex="1">'
				+ '              <div class="num-input">'
				+ '                <ul>'
				+ '                  <li class="num">'
				+ '                    <input'
				+ '                      type="text"'
				+ '                      name="info-' + infoIndex + '-number-1"'
				+ '                      placeholder="半角数字"'
				+ '                      maxLength="255"'
				+ '                    >'
				+ '                  </li>'
				+ '                  <li class="add-btn">'
				+ '                    <a href="javascript:void(0);" class="addition" data-infoindex="' + infoIndex + '"></a>'
				+ '                  </li>'
				+ '                </ul>'
				+ '              </div>'
				+ '            </div>'
				+ '          </li>'
				+ '        </ul>'
				+ '      </div>'
				+ '      <h2 class="title">健康保険証情報を入力してください</h2>'
				+ '      <div class="form-box">'
				+ '        <ul class="form-parts">'
				+ '          <li class="name h-card"><span class="required">必須</span>保険者番号</li>'
				+ '          <li>'
				+ '            <div class="input-box">'
				+ '              <div class="input">'
				+ '                <input type="text" name="info-' + infoIndex + '-insurance_card_insurer_number" placeholder="半角数字" maxLength="255">'
				+ '              </div>'
				+ '            </div>'
				+ '          </li>'
				+ '        </ul>'
				+ '        <ul class="form-parts">'
				+ '          <li class="name h-card"><span class="any">任意</span>記号</li>'
				+ '          <li>'
				+ '            <div class="input-box">'
				+ '              <div class="input">'
				+ '                <input type="text" name="info-' + infoIndex + '-insurance_card_symbol" placeholder="半角数字" maxLength="255">'
				+ '              </div>'
				+ '            </div>'
				+ '          </li>'
				+ '        </ul>'
				+ '        <ul class="form-parts">'
				+ '          <li class="name h-card"><span class="required">必須</span>番号</li>'
				+ '          <li>'
				+ '            <div class="input-box">'
				+ '              <div class="input">'
				+ '                <input type="text" name="info-' + infoIndex + '-insurance_card_number" placeholder="半角数字" maxLength="255">'
				+ '              </div>'
				+ '            </div>'
				+ '          </li>'
				+ '        </ul>'
				+ '        <ul class="form-parts">'
				+ '          <li class="name h-card"><span class="any">任意</span>枝番<span class="sub-red">※処方内容（控え）に記載の通り入力を行ってください</span></li>'
				+ '          <li>'
				+ '            <div class="input-box">'
				+ '              <div class="input">'
				+ '                <input type="text" name="info-' + infoIndex + '-insurance_card_branch_number" placeholder="半角数字" maxLength="2">'
				+ '              </div>'
				+ '            </div>'
				+ '          </li>'
				+ '        </ul>'
				+ '      </div>'
				+ '    </div>'
				+ '    <div class="delete-btn"><a href="javascript:void(0);">内容を削除する</a></div>'
				+ '  </div>';

			tar.before(elem);
			addExchangeInput();

			$("[name='info-" + infoIndex + "-birthday[year]']").val("1995");
			$("[name='info-" + infoIndex + "-birthday[month]']").val("01");
			$("[name='info-" + infoIndex + "-birthday[day]']").val("01");

			initEvent();
			infoIndex++;
		});
	};
	initEvent();

});
